import type { Persona } from "./context/AnalyzeFileContext";

export type AdvisorAvatarTheme = {
  ring: string;
  halo: string;
  fill: string;
  fallback: string;
  glow: string;
  bar: string;
};

export const ADVISOR_AVATAR_THEME: Record<string, AdvisorAvatarTheme> = {
  site_safety: {
    ring: "ring-red-300",
    halo: "bg-red-500/25",
    fill: "bg-gradient-to-br from-red-400 to-red-600",
    fallback: "bg-gradient-to-br from-red-500 to-red-700 text-white",
    glow: "shadow-[0_0_0_3px_rgba(248,113,113,0.45)]",
    bar: "bg-red-500",
  },
  workmanship: {
    ring: "ring-orange-300",
    halo: "bg-orange-500/25",
    fill: "bg-gradient-to-br from-orange-400 to-orange-600",
    fallback: "bg-gradient-to-br from-orange-500 to-orange-700 text-white",
    glow: "shadow-[0_0_0_3px_rgba(251,146,60,0.45)]",
    bar: "bg-orange-500",
  },
  analyze: {
    ring: "ring-sky-300",
    halo: "bg-sky-500/25",
    fill: "bg-gradient-to-br from-sky-400 to-sky-600",
    fallback: "bg-gradient-to-br from-sky-500 to-sky-700 text-white",
    glow: "shadow-[0_0_0_3px_rgba(56,189,248,0.45)]",
    bar: "bg-sky-500",
  },
  execute: {
    ring: "ring-emerald-300",
    halo: "bg-emerald-500/25",
    fill: "bg-gradient-to-br from-emerald-400 to-emerald-600",
    fallback: "bg-gradient-to-br from-emerald-500 to-emerald-700 text-white",
    glow: "shadow-[0_0_0_3px_rgba(52,211,153,0.45)]",
    bar: "bg-emerald-500",
  },
  review: {
    ring: "ring-violet-300",
    halo: "bg-violet-500/25",
    fill: "bg-gradient-to-br from-violet-400 to-violet-600",
    fallback: "bg-gradient-to-br from-violet-500 to-violet-700 text-white",
    glow: "shadow-[0_0_0_3px_rgba(167,139,250,0.45)]",
    bar: "bg-violet-500",
  },
};

const DEFAULT_AVATAR_THEME: AdvisorAvatarTheme = {
  ring: "ring-primary",
  halo: "bg-primary/15",
  fill: "bg-primary",
  fallback: "bg-primary text-primary-foreground",
  glow: "shadow-[0_0_0_3px_hsl(var(--primary)/0.35)]",
  bar: "bg-primary",
};

/** Silhouette assets from the API are black — invert to white on the saturated fill. */
export const ADVISOR_AVATAR_IMAGE_CLASS =
  "h-full w-full object-contain p-1.5 brightness-0 invert drop-shadow-[0_1px_2px_rgba(0,0,0,0.25)]";

export const getAdvisorTheme = (personaId: Persona["id"]): AdvisorAvatarTheme =>
  ADVISOR_AVATAR_THEME[personaId] ?? DEFAULT_AVATAR_THEME;

export const getAccentBg = (personaId: Persona["id"]): string => getAdvisorTheme(personaId).bar;
